import { Component, ErrorInfo, ReactNode } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Refresh } from '@mui/icons-material';

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    padding: 4,
    backgroundColor: '#f5f5f5'
  },
  message: {
    textAlign: 'center',
    mb: 3,
    color: '#d32f2f'
  },
  description: {
    textAlign: 'center',
    mb: 2
  },
  button: {
    mt: 2
  }
};

interface Props {
  children?: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    console.error('Application error:', error, errorInfo);
  }

  handleReload = (): void => {
    window?.location?.reload();
  };

  render() {
    if (this.state?.hasError) {
      return (
        <Box sx={styles.container}>
          <Typography variant="h5" sx={styles.message}>
            Something went wrong
          </Typography>
          <Typography variant="body2" sx={styles.description}>
            Please try refreshing the page
          </Typography>
          <Button
            variant="contained"
            startIcon={<Refresh />}
            onClick={this.handleReload}
            sx={styles.button}
          >
            Refresh
          </Button>
        </Box>
      );
    }

    return this.props?.children ?? null;
  }
}

export default ErrorBoundary;